import React,{useState,useEffect,useRef} from 'react';
import { BeatLoader } from 'react-spinners';
import { NotificationManager,NotificationContainer} from 'react-notifications';
import { Card,CardText,Button,TextField ,CardActions,FontIcon, CardTitle} from 'react-md';

const styles = {
    container:{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        padding:'1em'
    },
    loginPanel:{
        maxWidth:'25%',
        minWidth:'350px' 
    }
}



const ChangePasswordPage = ({history,apiService}) => {
    const {location} = history;
    const [loading,setLoading] = useState(true);
    const pathname = location.pathname;
    const key = pathname.replace('/change-password/','');
    const [userName,setUserName] = useState('');
    const passwordRef = useRef(null);
    const passwordConfirmRef = useRef(null);
    const [passwordError1,setPasswordError1] = useState(false);
    const [passwordErrorText1,setPasswordErrorText1] = useState('Please enter the password');
    const [passwordError,setPasswordError] = useState(false);
    const [passwordErrorText,setPasswordErrorText] = useState('Please enter the password again')
    useEffect(() => {
        if(key && key.length > 0)
            getUserName();
    }, [key])

    const validatePassword = (password)=> {
        if (password.match(/[a-z]/g) && password.match( 
                /[A-Z]/g) && password.match( 
                /[0-9]/g) && password.match( 
                /[^a-zA-Z\d]/g) && password.length >= 8) 
           return true;
        else 
            return false; 
    }

    const isValid = () => {
        setPasswordError(false);
        setPasswordError1(false);
        
        if(!validatePassword(passwordRef.current.value)){
            setPasswordError1(true);
            setPasswordErrorText1(`At least 1 uppercase character.
            At least 1 lowercase character.
            At least 1 digit.
            At least 1 special character.
            Minimum 8 characters.`);
            passwordRef.current.focus();
            return false;
        }

        if(passwordConfirmRef.current.value.length <= 0){
            passwordConfirmRef.current.focus();
            return false;
        }else{
            
            if(passwordConfirmRef.current.value !== passwordRef.current.value){
                
                setPasswordErrorText('Both Passwords must match');
                setPasswordError(true)
                passwordConfirmRef.current.focus();
                return false;
            }
        }

        return true;
    }

    const getUserName = () => {
        let responsePromise = apiService({
            method: 'get',
            url: '/getUserName/'+key,
            skipErrorHandle:true
        });
        responsePromise.then(res => {
            if(res.data){
                if(res.data && res.data.status === 1 && res.data.message){
                    NotificationManager.error(res.data.message, 'ERROR', 10000);
                   return;
                }
                //Redirect to Login
                setUserName(res.data.data)
            }else{
                console.debug("Server didn't respond", 'ERROR', 10000);
                return;
            }
        }).catch(error => {
            console.debug('Unable to fetch User name',error);
        }).finally(()=>{
            setLoading(false);
        });
    }

    const changePassword = (event) => {
        event.preventDefault();
        console.log('isValid()',isValid());
        
        if(!isValid())
            return;
        setLoading(true);
            let responsePromise = apiService({method: 'post',
            url: '/change-password',
            data:{
                'resetKey':key,
	            'password':passwordRef.current.value
            },
            skipErrorHandle:true});
              responsePromise.then(res => {
                if(res.data){
                    if(res.data && res.data.status === 1 && res.data.message){
                        NotificationManager.error(res.data.message, 'ERROR', 10000);
                        return;
                    }
                    //Redirect to Login
                    
                    NotificationManager.success("Password Reset Successfully", 'Success', 10000);
                    
                    setTimeout(()=>{
                        history.push('/');
                    },2000);
                   
                }
                else{
                    NotificationManager.error("Server didn't respond", 'ERROR', 10000);
                    return;
                }

              }).catch(error => {
                NotificationManager.error("Unable to activate, please contact your course instructor", 'ERROR', 10000);
              }).finally(()=>{
                setLoading(false);
              });
    }
    
   

    if (key && key.length > 0 && pathname.includes('/change-password/')){
        return <div style={styles.container}>
        {
            loading?
            <BeatLoader color='#bb0000' loading={true} size={10} />:
            <form onSubmit={changePassword}  style={styles.loginPanel} >
                <Card className="md-block-centered" >
                    <CardTitle>
                        Change Password
                    </CardTitle>
                    <CardText>
                        <TextField error={passwordError1}  errorText={passwordErrorText1} autoComplete='current-password' id='password' ref={passwordRef} label='Password' required leftIcon={<FontIcon>lock</FontIcon>} placeholder='Enter your essential skills password'  type="password"></TextField>
                        <TextField  error={passwordError} errorText={passwordErrorText} autoComplete='current-password' id='password1' ref={passwordConfirmRef} label='Password' required leftIcon={<FontIcon>lock</FontIcon>} placeholder='Enter your essential skills password'  type="password"></TextField>
                        <CardActions style ={{padding:"0px",justifyContent: "center"}}>
                            <Button type='submit'  primary raised onSubmit={changePassword}>Change Password</Button>
                        </CardActions>
                    </CardText>
                </Card>
           </form>
        }
        <NotificationContainer/>
        </div>
    }else{
        return <p>invalid or empty key</p>
    }
    
   
}

export default ChangePasswordPage;